/** Build id baked in at compile time (see vite/versionJsonPlugin.js). */
export const APP_BUILD_ID = import.meta.env.VITE_APP_BUILD_ID || 'dev';

/** @type {readonly string} */
export const VERSION_JSON_PATH = '/version.json';

/** Default poll interval when checking for a new deployment. */
export const APP_UPDATE_POLL_MS = 5 * 60 * 1000;
